import { useEffect, useState } from 'react';

export interface UTMParams {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
  /** Macro Meta `{{campaign.id}}_{{adset.id}}_{{ad.id}}`; el backend lo parsea en IDs de objeto. */
  utm_id?: string;
}

export function useUTMParams(): UTMParams {
  const [utmParams, setUtmParams] = useState<UTMParams>({});

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    const params: UTMParams = {
      utm_source: urlParams.get('utm_source') || undefined,
      utm_medium: urlParams.get('utm_medium') || undefined,
      utm_campaign: urlParams.get('utm_campaign') || undefined,
      utm_content: urlParams.get('utm_content') || undefined,
      utm_term: urlParams.get('utm_term') || undefined,
      utm_id: urlParams.get('utm_id') || undefined,
    };

    const storedParams = sessionStorage.getItem('utm_params');
    if (params.utm_source) {
      sessionStorage.setItem('utm_params', JSON.stringify(params));
      setUtmParams(params);
    } else if (storedParams) {
      setUtmParams(JSON.parse(storedParams));
    }
  }, []);

  return utmParams;
}

export function getTrafficSourceTag(utmSource?: string): string {
  if (!utmSource) return 'migro-leads';

  const source = utmSource.toLowerCase();

  if (source.includes('tiktok')) return 'tiktok-lead';
  if (source.includes('instagram') || source.includes('ig')) return 'instagram-lead';
  if (source.includes('youtube') || source.includes('yt')) return 'youtube-lead';
  if (source.includes('facebook') || source.includes('fb') || source.includes('meta')) return 'facebook-lead';

  return 'migro-leads';
}
